import React, { useState } from 'react';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../facturotopia';
import PeriodoRetencion from '../../support/catalogos/PeriodoRetencion';
import EjercicioRetencion from '../../support/catalogos/EjercicioRetencion';

const PeriodoForm = (props) => {
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  const getRules = (data) => {
    return {
      MesIni: ['required', 'numeric', 'min:1', 'max:12'],
      MesFin: ['required', 'numeric', 'min:1', 'max:12'],
      Ejercicio: ['required', 'integer', 'min:2021', 'max:2027'],
    };
  };

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
    };

    const validator = validate(data);

    props.onFormDataChange(
      {
        Periodo: data,
      },
      {
        step: 'periodo',
        name: 'isValidPeriodo',
        isValid: validator.passes(),
      }
    );
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const { data = {} } = props;
  const rules = getRules(data);

  return (
    <Row>
      <Col
        sm
        md={3}
      >
        <FormControl
          type="select"
          label="Mes Inicial"
          name="MesIni"
          placeholder=""
          help=""
          rules={rules.MesIni}
          value={data.MesIni}
          options={PeriodoRetencion}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={3}
      >
        <FormControl
          type="select"
          label="Mes Final"
          name="MesFin"
          placeholder=""
          help=""
          rules={rules.MesFin}
          value={data.MesFin}
          options={PeriodoRetencion}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={3}
      >
        <FormControl
          type="select"
          label="Ejercicio Fiscal"
          name="Ejercicio"
          placeholder=""
          help=""
          rules={rules.Ejercicio}
          value={data.Ejercicio}
          options={EjercicioRetencion}
          onChange={handleOnChange}
        />
      </Col>
    </Row>
  );
};

export default PeriodoForm;
